import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ListRequestParams } from 'modules/domain/types'
import { ASelectFilter } from 'views/components/Analytics'
import { UsContractTypes } from 'modules/domain/usContracts/types'

type Props = {
  listRequestParams: ListRequestParams
  updateFilterState: any
  disabled?: boolean
}

export const ContractTypeFilter: FC<Props> = ({ updateFilterState, listRequestParams, disabled }) => {
  const { t } = useTranslation('usContracts')
  const options = [
    {
      value: UsContractTypes.sale,
      label: t('contractTypes.sale'),
    },
    {
      value: UsContractTypes.purchase,
      label: t('contractTypes.purchase'),
    },
  ]
  return (
    <ASelectFilter
      placeholder={t('fields.contractType')}
      options={options}
      value={listRequestParams.filter.contract_type}
      onChange={(contract_type) => updateFilterState({ contract_type })}
      disabled={disabled}
      showSearch={false}
      id="contractTypeFilter"
    />
  )
}
